import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { Ribbon } from '@woovi/ui';
import { convertToCurrency } from '@woovi/utils';

import type { PaymentLinkActiveEarnDiscount_charge$key } from './__generated__/PaymentLinkActiveEarnDiscount_charge.graphql.ts';

import type { ReactNode } from 'react';

type PaymentLinkActiveEarnDiscountProps = {
  charge: PaymentLinkActiveEarnDiscount_charge$key;
};
const PaymentLinkActiveEarnDiscount = (
  props: PaymentLinkActiveEarnDiscountProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const charge = useFragment<PaymentLinkActiveEarnDiscount_charge$key>(
    graphql`
      fragment PaymentLinkActiveEarnDiscount_charge on Charge {
        discount
      }
    `,
    props.charge,
  );

  if (!charge?.discount) {
    return null;
  }

  const earnDiscountValue = convertToCurrency(charge.discount / 100);

  return (
    <Ribbon>
      <Typography>🤑</Typography>
      <Typography color={theme.palette.tertiary.main} sx={{ fontSize: '16px' }}>
        {t('You earned')} <b>{earnDiscountValue}</b> {t('of discount')}
      </Typography>
    </Ribbon>
  );
};

export default PaymentLinkActiveEarnDiscount;
